import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'

import { Dropdown, DropdownItem } from '../../../styles/defaults-header'

class ServiceMenu extends Component {
  handleClick(e) {
    this.props.onClickLink(e)
  }

  render() {
    const current = this.props.history.location.pathname
    return (
      <Dropdown>
        <DropdownItem current={current === '/faq'}>
          <Link to="/faq" onClick={this.handleClick.bind(this)}>
            FAQ
          </Link>
        </DropdownItem>

        {this.props.permissions.reportError ? (
          <DropdownItem current={current === '/storing-melden'}>
            <Link to="/storing-melden">Storingen melden</Link>
          </DropdownItem>
        ) : null}

      </Dropdown>
    )
  }
}

export default withRouter(ServiceMenu)



// WEBPACK FOOTER //
// ./src/components/Header/ServiceMenu/index.js